import { makeStyles } from '@material-ui/core/styles'

const headerStyles = makeStyles((theme) => ({
  programHeaderBar: {
    // border : '2px solid black',
    // margin: '2% 2% 1.3%',
    padding: '25px 41px 0px 41px',
    height: '4em',
    background: '#FFFFFF',
    display: 'flex',
  },
  programDetailsDynamic: {
    display: 'flex',
    alignItems: 'center', //vertical center of the parent element
    justifyContent: 'flex-start',
    // border : '2px solid black',
    width: '60%',
  },
  programDetailsStatic: {
    display: 'flex',
    alignItems: 'center', //vertical center of the parent element
    justifyContent: 'flex-end',
    // border : '2px solid black',
    width: '40%',
  },
  programTitle: {
    // border : '2px solid black',
    color: '#335977',
    fontWeight: 'bold',
    fontSize: '2.5em',
    marginRight: '4%',
  },
  staticMargin: {
    marginLeft: '3%',
  },
  popWrapper: {
    padding: '30px',
    color: '#565657',
    fontSize: '16px',
    textAlign: 'center',
  },
  ackButton: {
    marginTop: '20px',
    width: 'auto',
    height: 'auto',
  },
  popText: {
    fontSize: '18px',
  },
}))

export { headerStyles }
